import React, { useCallback, useEffect, useState } from "react";
import Confetti, { type Props } from "react-confetti";

import { zindexConfetti } from "~/css/zindexes";
import { useWindowSize } from "~/lib/hooks";

export const GRAVITY_CONSTANT = 0.15;

export default function ConfettiCannons({
	isRainingConfetti: isRainingConfettiRight,
	setIsRainingConfetti: setIsRainingConfettiRight,
}: {
	isRainingConfetti: boolean;
	setIsRainingConfetti: (isRainingConfetti: boolean) => void;
}) {
	const { width: windowWidth, height: windowHeight } = useWindowSize();
	const [isRainingConfettiLeft, setIsRainingConfettiLeft] = useState(false);
	const [isRainingConfettiAbove, setIsRainingConfettiAbove] = useState(false);
	useEffect(() => {
		if (!isRainingConfettiRight) {
			return;
		}

		const timeout1 = setTimeout(() => {
			setIsRainingConfettiLeft(isRainingConfettiRight);
		}, 150);

		const timeout2 = setTimeout(() => {
			setIsRainingConfettiAbove(isRainingConfettiRight);
		}, 750);

		return () => {
			clearTimeout(timeout1);
			clearTimeout(timeout2);
		};
	}, [isRainingConfettiRight]);

	const confettiHandler = useCallback<
		(setStateFn: (value: boolean) => void) => NonNullable<Props["onConfettiComplete"]>
	>(
		setStateFn => confetti => {
			setStateFn(false);
			confetti?.reset();
		},
		[],
	);

	if (!(isRainingConfettiRight || isRainingConfettiLeft || isRainingConfettiAbove)) {
		return null;
	}

	return (
		<>
			<Confetti
				style={{ zIndex: zindexConfetti }}
				numberOfPieces={isRainingConfettiAbove ? 500 : 0}
				recycle={false}
				initialVelocityY={{ min: 2, max: 5 }}
				gravity={GRAVITY_CONSTANT}
				width={windowWidth}
				height={windowHeight}
				tweenDuration={10000}
				onConfettiComplete={confettiHandler(setIsRainingConfettiAbove)}
			/>
			<Confetti
				style={{ zIndex: zindexConfetti }}
				numberOfPieces={isRainingConfettiLeft ? 500 : 0}
				recycle={false}
				confettiSource={{
					x: -windowWidth / 20,
					y: (windowHeight / 10) * 9,
					w: windowWidth / 20,
					h: windowHeight / 10,
				}}
				initialVelocityY={GRAVITY_CONSTANT * 300}
				initialVelocityX={windowWidth / 80}
				gravity={GRAVITY_CONSTANT}
				width={windowWidth}
				height={windowHeight}
				tweenDuration={100}
				onConfettiComplete={confettiHandler(setIsRainingConfettiLeft)}
			/>
			<Confetti
				style={{ zIndex: zindexConfetti }}
				numberOfPieces={isRainingConfettiRight ? 500 : 0}
				recycle={false}
				confettiSource={{
					x: windowWidth,
					y: (windowHeight / 10) * 9,
					w: windowWidth / 20,
					h: windowHeight / 10,
				}}
				initialVelocityY={GRAVITY_CONSTANT * 300}
				initialVelocityX={-windowWidth / 80}
				gravity={GRAVITY_CONSTANT}
				width={windowWidth}
				height={windowHeight}
				tweenDuration={100}
				onConfettiComplete={confettiHandler(setIsRainingConfettiRight)}
			/>
		</>
	);
}
